var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLavoroBowl(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.114,
    x2: 1,
    y2: 0.864,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#442eb2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#d8583d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fa9c2b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-446 -413.455)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 16.08,
    cy: 16.528,
    rx: 16.08,
    ry: 16.528,
    transform: "translate(446 416.4)",
    fill: "rgba(250,156,43,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31004",
    "data-name": "Group 31004",
    transform: "translate(453.619 413.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15935",
    "data-name": "Path 15935",
    d: "M0,0H21.286a7.1,7.1,0,0,1,7.1,7.1V9.934H7.1A7.1,7.1,0,0,1,0,2.838Z",
    transform: "translate(0 18.448)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_632",
    "data-name": "Union 632",
    d: "M9.934,9.934V.721a8.207,8.207,0,0,0,2.2,5.365c2.483,2.483,7.729,3.848,7.729,3.848Zm-2.838,0A7.1,7.1,0,0,1,0,2.838V0H9.934V9.934Z",
    transform: "translate(4.257 18.448)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_634",
    "data-name": "Union 634",
    d: "M9.934,9.934V.721a8.207,8.207,0,0,0,2.2,5.365c2.483,2.483,7.729,3.848,7.729,3.848Zm-2.838,0A7.1,7.1,0,0,1,0,2.838V0H9.934V9.934Z",
    transform: "translate(2.129 18.448)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_633",
    "data-name": "Union 633",
    d: "M9.934,28.381V19.169a8.209,8.209,0,0,0,2.2,5.365c2.483,2.483,7.729,3.848,7.729,3.848Zm-2.838,0a7.1,7.1,0,0,1-7.1-7.1V0H2.838a7.1,7.1,0,0,1,7.1,7.1V28.381Z",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLavoroBowl);
export default __webpack_public_path__ + "static/media/lavoro-bowl.5bd9fac2ac61349d2c07c3f971b5519c.svg";
export { ForwardRef as ReactComponent };